<!--==================================
=            CHARTPIEAPEX            =
===================================-->
<template><div justify center >
  <div id="chart3"></div></div>
</template>
<script>
export default {
  mounted() {
    var options = {
      chart: {
        height: 360,
        type: "radialBar"
      },
      plotOptions: {
        radialBar: {
          offsetY: -10,
          startAngle: 0,
          endAngle: 270,
          hollow: {
            margin: 5,
            size: "30%",
            background: "transparent",
            image: undefined
          },
          dataLabels: {
            name: {
              show: false
            },
            value: {
              show: false
            }
          }
        }
      },
      colors: ["#845EC2", "#A178DF", "#BE93FD", "#DCB0FF"],
      series: [76, 67, 61, 90],
      labels: ["Vimeo", "Messenger", "Facebook", "LinkedIn"],
      legend: {
        show: false,
        floating: true,
        fontSize: "16px",
        position: "left",
        offsetX: 160,
        offsetY: 10,
        labels: {
          useSeriesColors: false
        },
        markers: {
          size: 0
        },
        formatter: function(seriesName, opts) {
          return seriesName + ":  " + opts.w.globals.series[opts.seriesIndex];
        },
        itemMargin: {
          horizontal: 1
        }
      },
      responsive: [
        {
          breakpoint: 480,
          options: {
            legend: {
              show: false
            }
          }
        }
      ]
    };
 // eslint-disable-next-line no-undef
    // eslint-disable-next-line no-redeclare
    var chart = new ApexCharts(document.querySelector("#chart3"), options);

    chart.render();
  }
};
</script>

<!--====  End of CHARTPIEAPEX  ====-->
